module.exports = __webpack_public_path__ + "images/job/detail/detail_icon05-a2906f9b49d93dda7e2fab5fe05b0d44.png";